import moment from 'moment'

export const THREADED = 1
export const UNTHREADED = 2
export const INBOX_TYPE_PERSONAL = 'personal'
export const INBOX_TYPE_CONNECTED = 'connected'
export const INBOX_TYPE_WATCHING = 'watching'
export const INBOX_TYPE_ALL = 'all'
export const ALL_INBOXES_ID = 'all'
export const SEARCH_FIELDS = ['lead_number', 'contact.name', 'campaign.name']

// Classify the current user's relationship to an inbox from its membership
// fields. Shared by the nav-list grouping and the watch-only communication guard
// so both stay in sync. `teamsIds` is the list of team ids the user belongs to.
// Inbox list items carry team members as `team_user_ids`; ring group broadcasts
// nest them under `teams[].users`.
export function classifyInboxMembership (inbox, profileId, teamsIds = []) {
  if (!inbox) {
    return { isConnected: false, isWatching: false }
  }

  const isConnected = inbox.user_ids?.includes(profileId) ||
    inbox.team_ids?.some(id => teamsIds.includes(id)) ||
    inbox.team_user_ids?.includes(profileId) ||
    inbox.teams?.some(team => team.users?.some(user => user.id === profileId))

  const isWatching = inbox.watcher_user_ids?.includes(profileId) ||
    inbox.watcher_team_user_ids?.includes(profileId) ||
    inbox.watcher_team_ids?.some(id => teamsIds.includes(id))

  return {
    isConnected: Boolean(isConnected),
    isWatching: Boolean(isWatching)
  }
}

// Date filter type constants
export const DATE_FILTER_TYPE_LAST_ENGAGEMENT = 'last_engagement'
export const DATE_FILTER_TYPE_ANY_ENGAGEMENT = 'any_engagement'

export const DEFAULT_FILTERS = {
  channels: [],
  campaigns: [],
  directions: [],
  my_contact: false,
  unread_only: false,
  hide_opted_out: false,
  mention: false,
  date_range: 'Last 30 Days',
  from_date: moment().subtract(30, 'days').startOf('day').format('YYYY-MM-DD HH:mm:ss'),
  to_date: moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
  date_filter_type: DATE_FILTER_TYPE_ANY_ENGAGEMENT,
  inboxes: []
}

export default function () {
  return {
    activeInboxId: null,
    activeInbox: {},
    inboxes: [],
    hasAnyInboxes: false, // Flag to track if user has any inboxes (from initial load)
    isLoadingInboxes: false,
    inboxesUnreadCount: [],
    isLoadingInboxesUnreadCount: false,
    currentInboxesPage: 0,
    hasMoreInboxes: true,
    viewMode: THREADED,
    items: [],
    isLoadingItems: false,
    isLoadingMoreItems: false,
    currentItemsPage: 0,
    hasMoreItems: true,
    syncMarker: null,
    abortController: null,
    unreadCountAbortController: null,
    showRefreshInboxesButton: false,
    showRefreshCommunicationsButton: false,
    activeFilters: { ...DEFAULT_FILTERS },
    selectedFilter: null,
    activeSort: {},
    currentSearch: null,
    isInitialLoad: false,
    activeInboxContactUnreadCount: 0,
    inboxAnnouncementViewed: false,
    unreadCountLoaded: false,
    contactsLastUsedLines: new Map(),
    contactsLastUsedLinesUpdatedAt: null,
    loadingTeamInboxCampaigns: false,
    teamInboxCampaigns: []
  }
}
